import { useContext } from "react";
import ModalContext from "../context/modals";

export const useModals = () => useContext(ModalContext);